import * as React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Gauge from 'react-svg-gauge';

const useStyles = makeStyles((theme) => ({
    rechartBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '100%',
    },
    title: {
        color: "#4D5766",
        wordSpacing: 2,
        fontSize: 18,
        marginTop: theme.spacing(1),
        [theme.breakpoints.down('xs')]: {
            fontSize: 14,
        },
    },
    gaugeWrapper: {
        maxWidth: '100%',
        overflow: 'hidden',
    },
}));

const getScoreTitle = (score) => {
    if (score >= 0 && score < 1.5) return "Initiating";
    if (score >= 1.5 && score < 2.5) return "Emerging";
    if (score >= 2.5 && score < 3.5) return "Performing";
    if (score >= 3.5 && score < 4.5) return "Advancing";
    if (score >= 4.5) return "Leading";
    return "Initiating";
};

const GaugeDesignComponent = ({ score }) => {
    const classes = useStyles();
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('xs'));
    const isSm = useMediaQuery(theme.breakpoints.down('sm'));
    const isMd = useMediaQuery(theme.breakpoints.between('sm', 'lg')); // 600px–1200px: table beside gauges
    const numericScore = isNaN(Number(score)) ? 0 : Number(score);
    const scoreTitle = getScoreTitle(numericScore);

    // Balanced sizes: smaller at md so table fits, medium at lg, full at xl
    const gaugeWidth = isXs ? 200 : isSm ? 240 : isMd ? 240 : 280;
    const gaugeHeight = isXs ? 160 : isSm ? 200 : isMd ? 200 : 233;
    const valueFontSize = isXs ? 22 : isSm ? 26 : isMd ? 24 : 28;

    return (
        <div className={classes.rechartBox}>
            <div className={classes.gaugeWrapper}>
                <Gauge
                    value={numericScore}
                    max={5}
                    color="#143177"
                    label={''}
                    width={gaugeWidth}
                    height={gaugeHeight}
                    topLabelStyle={{ display: 'none' }}
                    valueLabelStyle={{ fontSize: valueFontSize, fill: '#000000' }}
                    valueFormatter={number => number}
                />
            </div>
            <div className={classes.title}>{scoreTitle}</div>
        </div>
    );
};

export default GaugeDesignComponent;
